import React from "react";
import { STATUS } from "@/data/seed";
import { StatusDot } from "@/components/StatusBadge";
import { cn } from "@/lib/utils";

// Square, glowing-bordered avatar whose ring color reflects the current status.
export function EmployeeAvatar({ employee, size = 56, showStatus = true, className, onClick, active }) {
  const s = STATUS[employee.status] || STATUS.available;
  const clickable = typeof onClick === "function";
  return (
    <div
      className={cn("relative shrink-0", clickable && "cursor-pointer", className)}
      style={{ width: size, height: size }}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => (e.key === "Enter" || e.key === " ") && onClick(e) : undefined}
      data-testid={`avatar-${employee.id}`}
    >
      <div
        className="h-full w-full overflow-hidden rounded-xl transition-transform duration-300"
        style={{
          border: `1.5px solid ${s.color}`,
          boxShadow: active ? `0 0 22px ${s.color}88` : `0 0 12px ${s.color}44`,
        }}
      >
        <img src={employee.avatar} alt={employee.name} className="h-full w-full object-cover" loading="lazy" />
      </div>
      {showStatus && (
        <span className="absolute -bottom-1 -right-1 rounded-full bg-[#030A16] p-0.5">
          <StatusDot status={employee.status} />
        </span>
      )}
    </div>
  );
}
